var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as funcoesPDF from '../../Biblioteca/FuncoesPDF';
/**
 * Modelo para gerar os componentes dos graficos para o jsPDF
 * Permiter que o grafico tenha titulo e legenda
 */
export class GraficoPDF {
    constructor(config, svg, title, legendData) {
        this.config = config;
        this.svg = svg;
        this.title = title || '';
        this.legendData = legendData || null;
    }
    /**
     *
     * @param docObj PDF
     * @param width Largura do SVG
     * @param height Altura do SVG
     * @param legenda (Opcional) Tabela que representa a legenda
     * @param alignTitle (Default center) Alinhamento do titulo do grafico
     * @param alignLegend (Default center) Alinhamento da legenda do grafico
     * @param marginBottom (Default 0) Acrescenta uma distância na altura do Grafico
     * @returns
     */
    configurarGrafico(docObj, width, height, legenda, alignTitle = 'center', alignLegend = 'center', marginBottom = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const graficoClasseSVG = {
                html: this.svg,
                width,
                height,
                marginBottom,
            };
            const titulo = this.title !== '' ? docObj.criarTituloGrafico(this.title) : undefined;
            const component = yield funcoesPDF.gerarGrafico(this.config, graficoClasseSVG, titulo, legenda, alignTitle, alignLegend);
            return component;
        });
    }
}
